export interface NavContent {
	resumo: string;
	destaques: string;
	revelacoes: string;
	faturamento: string;
	ranking: string;
	tempoOperacao: string;
	curiosidades: string;
}

export const navContent: NavContent = {
	resumo: "Início",
	destaques: "Destaques",
	revelacoes: "Revelações",
	faturamento: "Faturamento",
	ranking: "Ranking",
	tempoOperacao: "Tempo de Operação",
	curiosidades: "Curiosidades",
};
